import { FILE_TYPE } from '@/config/config'

function fillPos (val) {
  return parseInt(val) < 10 ? `0${val}` : val
}

export function getQueryString (name, search) {
  const re = new RegExp(name + '=([^&#]*)', 'i')
  const matched = re.exec(window.location.search)
  if (!matched) {
    return ''
  }
  return decodeURIComponent(matched[1])
}

/**
 * @param number时间s，时间对象
 * @returns yyyy-M-dd hh:mm:ss
 */
export function formatDate (date) {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const minutes = fillPos(date.getMinutes())
  const second = fillPos(date.getSeconds())
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  const time = [date.getHours(), minutes, second]
  return `${day.join('-')} ${time.join(':')}`
}

/**
 * @param number时间s，时间对象
 * @returns yyyy-M-dd
 */
export function formatDate2 (date) {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  return `${day.join('-')}`
}

export const getDomain = function () {
  const location = window.location
  return `${location.protocol}//${location.hostname}`
}

/**
 * @param JSON.stringif的值
 * @returns 对象
 */
export const jsonParse = function (str) {
  if (!(str && typeof str === 'string')) return {}

  try {
    return JSON.parse(str)
  } catch (e) {
    console.error(e, str)
  }

  return {}
}

export const noop = () => {}

export const filetypeValidator = (value) => {
  if (!value) return false
  return !!FILE_TYPE[value.toUpperCase()]
}

/**
 * 首字母大写
 * @param 字符串，英文
 */
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
// 生成一个32位16进制的uuid
export const getuuid = () => {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23]
  return s.join('')
}

export const getFileSizeText = (fileSize) => {
  if (!fileSize) return '0M'

  const _this = window.app
  return `${_this.$options.filters.fileUnit(fileSize, 'mb', 3)}M`
}
